import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CheckBox from '@components/CheckBox';
import { changeMentorEnableTimeTracking } from '@containers/Admin/containers/StaffPage/actions';
import { ItemWithLabel } from './ItemWithLabel';
import { ItemWithLabelWrapper } from './ItemWithLabel/styles';

export const EnableTimeTracking = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    userData: { id, mentorProperties },
  } = useSelector((state: RootStateOrAny) => state.get('staffPage').toJS()); // FIXME replace to typing store
  const { roles } = useSelector((state: RootStateOrAny) => state.getIn(['app', 'authentication', 'user']).toJS()); // FIXME replace to typing store
  const isSupervisor = roles.includes('30');
  const isTechAdmin = roles.includes('40');
  const isManagementAdmin = roles.includes('41');
  const canEdit = isTechAdmin || isSupervisor || isManagementAdmin;
  const enableTimeTracking = mentorProperties?.enableTimeTracking ?? true;

  const onChangeEnableTimeTracking = (checked: boolean): void => {
    dispatch(changeMentorEnableTimeTracking(checked, id));
  };

  if (!canEdit)
    return (
      <ItemWithLabel label={<span>{t('Informative.Labels.enableTimeTracking')}:</span>}>
        {enableTimeTracking ? t('Actions.Simple.yes') : t('Actions.Simple.no')}
      </ItemWithLabel>
    );

  return (
    <ItemWithLabelWrapper>
      <CheckBox
        value={enableTimeTracking}
        onChange={onChangeEnableTimeTracking}
        label={t('Informative.Labels.enableTimeTracking')}
      />
    </ItemWithLabelWrapper>
  );
};
